// extracted by mini-css-extract-plugin
module.exports = {"footerRow":"Footer_footerRow__2kYdt","footerDiv":"Footer_footerDiv__2TofN"};